var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    d: "M17.116 10.587c.22-1.497-.913-2.296-2.474-2.838l.505-2.017l-1.233-.307l-.492 1.968l-.984-.236l.5-1.982l-1.234-.306l-.506 2.025l-.785-.186v-.007L8.71 6.273l-.328 1.32s.913.214.898.22c.5.13.585.457.571.714l-.57 2.31l.128.043l-.135-.03l-.806 3.231c-.057.15-.214.378-.563.285c.014.021-.892-.214-.892-.214L6.4 15.557l1.605.399l.876.229l-.513 2.046l1.233.306l.5-2.025l.99.257l-.505 2.018l1.233.307l.506-2.047c2.103.4 3.687.243 4.35-1.661c.534-1.533-.029-2.41-1.134-2.995c.806-.178 1.412-.713 1.569-1.804zm-2.817 3.95c-.378 1.533-2.959.699-3.793.5l.678-2.717c.834.214 3.515.62 3.115 2.21zm.378-3.971c-.342 1.39-2.495.684-3.187.513l.613-2.46c.699.172 2.938.5 2.574 1.947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.d16476926fd0efbc082ca6b88f240451.svg";
export { ForwardRef as ReactComponent };